import React, { useContext, useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Field } from 'formik';

import InfoRequest from '../InfoRequest';

import Passengers from 'app/components/ServicesForms/Licenses/commonComponents/Passengers';
import Schedules from 'app/components/ServicesForms/Licenses/commonComponents/Schedules';
import Companies from 'app/components/ServicesForms/Licenses/commonComponents/Companies';
import AdditionalData from 'app/components/ServicesForms/Licenses/commonComponents/AdditionalData';
import VehicleTableAdd from 'app/components/ServicesForms/Licenses/commonComponents/VehicleTableAdd';
import Itinerary from 'app/components/ServicesForms/Licenses/commonComponents/Itinerary';

import { FormServiceContext } from 'app/utils/contexts';
import { SERVICES_PROPERTIES } from 'app/config/services';
import {
    clearCompaniesListLicensesDuplicate,
    clearItineraryListLicensesDuplicate,
    clearPassengersListLicensesDuplicate,
    clearScheduleListLicensesDuplicate,
    clearVehicleListToLicensesDuplicate,
} from 'app/utils/forms/services/licenses';

function Contract(props) {
    const { classes, values, setFieldValue, oldRequest, oldService, oldLicense } = props;
    const { canEdit } = useContext(FormServiceContext);

    const [hasVehicle, setHasVehicle] = useState(false);
    const [hasPassengers, setHasPassengers] = useState(false);
    const [hasSchedule, setHasSchedule] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [hasItinerary] = useState(false);
    const [hasCompanies, setHasCompanies] = useState(false);
    const [hasAditionalData, setHasAditionalData] = useState(false);

    useEffect(() => {
        const init = () => {
            const cdServico = oldService?.cdServico ? oldService.cdServico : oldRequest.cdServico;
            let configurator = {};
            if (cdServico && SERVICES_PROPERTIES[cdServico].configurator) {
                configurator = SERVICES_PROPERTIES[cdServico].configurator;
            }

            if (configurator.hasVehicle) setHasVehicle(true);
            if (configurator.hasPassengers) setHasPassengers(true);
            if (configurator.hasSchedules) setHasSchedule(true);
            if (configurator.hasCompanies) setHasCompanies(true);
            if (configurator.hasAditionalData) setHasAditionalData(true);
            // if (configurator.hasItinerary) setHasItinerary(true);
        };
        init();
    }, [oldRequest, oldService]);

    const [passengers, setPassengers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [itinerary, setItinerary] = useState([]);
    const [vehiclesOld, setVehiclesOld] = useState([]);
    const [itineraryOld, setItineraryOld] = useState([]);

    useEffect(() => {
        (async () => {
            if (values.licencaVeiculos && values.licencaVeiculos.length > 0) {
                setVehicles(values.licencaVeiculos);
            } else {
                if (oldLicense?.licencaVeiculos) {
                    const list = clearVehicleListToLicensesDuplicate(oldLicense?.licencaVeiculos);
                    setVehicles(list);
                    setFieldValue('licencaVeiculos', list);
                }
            }

            if (values.passageiros && values.passageiros.length > 0) {
                setPassengers(values.passageiros);
            } else {
                if (oldLicense?.passageiros) {
                    const list = clearPassengersListLicensesDuplicate(oldLicense?.passageiros);
                    setPassengers(list);
                    setFieldValue('passageiros', list);
                }
            }

            if (values.horarios && values.horarios.length > 0) {
                setSchedules(values.horarios);
            } else {
                if (oldLicense?.horarios) {
                    const list = clearScheduleListLicensesDuplicate(oldLicense?.horarios);
                    setSchedules(list);
                    setFieldValue('horarios', list);
                }
            }

            if (values.itinerario && values.itinerario.length > 0) {
                setItinerary(values.itinerario);
            } else {
                if (oldLicense?.itinerario) {
                    const list = clearItineraryListLicensesDuplicate(oldLicense?.itinerario);
                    setItinerary(list);
                    setFieldValue('itinerario', list);
                }
            }

            if (values.empresas && values.empresas.length > 0) {
                setCompanies(values.empresas);
            } else {
                if (oldLicense?.empresas) {
                    const list = clearCompaniesListLicensesDuplicate(oldLicense?.empresas);
                    setCompanies(list);
                    setFieldValue('empresas', list);
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.empresas, oldLicense?.empresas, setFieldValue]);

    const handleChangeLists = (list, type) => {
        // eslint-disable-next-line default-case
        switch (type) {
            case 'passengers':
                setPassengers(list);
                setFieldValue('passageiros', list);
                break;
            case 'vehicles':
                setVehicles(list);
                setFieldValue('licencaVeiculos', list);
                break;
            case 'itinerary':
                setItinerary(list);
                setFieldValue('itinerario', list);
                break;
            case 'schedules':
                setSchedules(list);
                setFieldValue('horarios', list);
                break;
            case 'companies':
                setCompanies(list);
                setFieldValue('empresas', list);
                break;
        }
    };

    useEffect(() => {
        const init = () => {
            if (oldLicense?.licencaVeiculos) {
                setVehiclesOld(oldLicense.licencaVeiculos);
            }
            if (oldLicense?.itinerario) {
                setItineraryOld(oldLicense.itinerario);
            }
        };
        init();
    }, [oldLicense]);

    return (
        <>
            <InfoRequest {...props} title={''} />

            <Grid item xs={12}>
                <h3 className={classes.greenTitle}>Informações NOVAS na licença</h3>
            </Grid>

            {hasVehicle && (
                <Grid item xs={12}>
                    <VehicleTableAdd
                        {...props}
                        classes={classes}
                        oldVehicles={vehiclesOld}
                        data={vehicles}
                        setData={(list) => handleChangeLists(list, 'vehicles')}
                    />
                </Grid>
            )}
            {hasPassengers && (
                <Grid item xs={12}>
                    <Passengers
                        {...props}
                        classes={classes}
                        data={passengers}
                        setData={(list) => handleChangeLists(list, 'passengers')}
                    />
                </Grid>
            )}
            {hasItinerary && (
                <Grid item xs={12}>
                    <Itinerary
                        {...props}
                        classes={classes}
                        oldItinerary={itineraryOld}
                        data={itinerary}
                        setData={(list) => handleChangeLists(list, 'itinerary')}
                    />
                </Grid>
            )}
            {hasSchedule && (
                <Grid item xs={12}>
                    <Schedules
                        {...props}
                        classes={classes}
                        data={schedules}
                        setData={(list) => handleChangeLists(list, 'schedules')}
                    />
                </Grid>
            )}
            {hasCompanies && (
                <Grid item xs={12}>
                    <Companies
                        {...props}
                        classes={classes}
                        data={companies}
                        setData={(list) => handleChangeLists(list, 'companies')}
                    />
                </Grid>
            )}
            {hasAditionalData && (
                <Grid item xs={12}>
                    <AdditionalData {...props} classes={classes} />
                </Grid>
            )}

            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit}
                    multiline
                    minRows={4}
                    fullWidth
                    as={TextField}
                    inputProps={{
                        maxLength: 5000,
                    }}
                />
            </Grid>
        </>
    );
}

export default Contract;
